import { render } from "./Message.vue?vue&type=template&id=1d10f058&scoped=true"
import script from "./Message.vue?vue&type=script&lang=js"
export * from "./Message.vue?vue&type=script&lang=js"

import "./Message.vue?vue&type=style&index=0&id=1d10f058&lang=scss&scoped=true"
import "./Message.vue?vue&type=style&index=1&id=1d10f058&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1d10f058"]])

export default __exports__